import {css} from '@emotion/react'
import {Select} from '@/components/Form'
import {useAiContext} from './AiContext.mjs'

const cssDraftSelect = css({
    width: 'auto',
})

export const DraftSelect = ({disabled, ...props}) => {
    const ai = useAiContext()

    return (
        <Select
            css={cssDraftSelect}
            bordered={false}
            disabled={disabled || ai.getIsDisabled()}
            size="small"
            dropdownMatchSelectWidth={false}
            {...props}
        />
    )
}
